import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { getTestLabels } from '../../utils/getTestLabels.js';

const { componentTestLabel } = getTestLabels('GridCol');
const buildClassName = (prefix, value, breakpoint) => {
    return value && `${prefix}-${value}${breakpoint ? `@${breakpoint}` : ''}`;
};
const buildBreakpointClassNames = (breakpointProps, breakpoint) => {
    const classes = [
        buildClassName('col-start', breakpointProps.start, breakpoint),
        buildClassName('col', breakpointProps.colSpan, breakpoint),
        buildClassName('row-start', breakpointProps.rowStart, breakpoint),
        buildClassName('row', breakpointProps.rowSpan, breakpoint),
        buildClassName('vertical-self', breakpointProps.verticalAlign, breakpoint),
    ];
    return classes;
};
const GridCol = forwardRef((props, ref) => {
    const { children, start, colSpan, rowStart, rowSpan, verticalAlign, sm, md, lg, xl, ...otherProps } = props;
    let dataGridAttrs = Object.entries({
        sm,
        md,
        lg,
        xl,
    }).flatMap(([breakpoint, props]) => props && buildBreakpointClassNames(props, breakpoint));
    dataGridAttrs = dataGridAttrs.concat(buildBreakpointClassNames({
        start,
        colSpan,
        rowStart,
        rowSpan,
        verticalAlign,
    }));
    return (jsx("div", { "data-zta": componentTestLabel, ref: ref, ...otherProps, 'data-z-grid': classNames(dataGridAttrs), children: children }));
});
GridCol.displayName = 'GridCol';
/**
 * @deprecated use `GridCol` instead (or better yet, use native css grid styles ([see MDN docs](https://developer.mozilla.org/en-US/docs/Web/CSS/grid))
 */
const Col = GridCol;

export { Col, GridCol };
//# sourceMappingURL=Col.js.map
